import React from 'react';
import { Grid } from '@mui/material';
import { SimpleDialog, ButtonLoading } from 'components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles((theme) => {
  return {
    customClassdialogContent: {
      minWidth: '440px',
      [theme.breakpoints.down('sm')]: {
        minWidth: 'auto',
      },
    },
  };
});
const MessageCartableDg = (props) => {
    const { isOpenDg,
        setIsOpenDg,
        requestId,
        navigate,
        scroll } = props;
    const classes = useStyles();
    return (


        <SimpleDialog
            fullWidth
            maxWidth="xs"
            customClass={classes.customClassdialogContent}
            open={isOpenDg}
            title='درخواست پرداخت فاکتور'
            onClose={() => setIsOpenDg(false)}

        >


            <Grid container alignItems="center" >
                <Grid style={{ position: 'relative', width: '100%' }}>
                    <Grid style={{ textAlign: 'center' }}>
                        درخواست شما در حال تایید توسط امضاداران می باشد. جهت مشاهده جزئیات درخواست، بر روی دکمه زیر کلیک نمایید.
                    </Grid>
                    <Grid md={12} xs={12} lg={12}
                        style={{  display: 'flex', marginTop: '16px', flexDirection:'row-reverse'}}
                    >

                        <ButtonLoading
                            type="button"
                            variant="contained"
                            color="primary"
                            style={{ width: '100%' }}
                            name="جزئیات درخواست "
                            onClick={() => {
                                scroll.scrollToTop();
                                setIsOpenDg(false);
                                if (requestId) {
                                    navigate(`/RequestPayDetails/${requestId}`);
                                } else {
                                    navigate('/CartableRequest/List');
                                }
                            }}
                        />

                    </Grid>
                </Grid>
            </Grid>


        </SimpleDialog>
    )
}

export default MessageCartableDg;

